var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 130,
    viewBox: "0 0 91 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4492 0C29.4562 0 16.4453 13.0109 16.4453 29.0039V51.9922L26.7578 58.4375L35.7812 51.9922V29.0039C35.7812 23.6736 40.1189 19.3359 45.4492 19.3359C50.7795 19.3359 55.1172 23.6736 55.1172 29.0039V42.3242C55.1172 44.1031 56.5609 45.5469 58.3398 45.5469H71.2305C73.0094 45.5469 74.4531 44.1031 74.4531 42.3242V29.0039C74.4531 13.0109 61.4422 0 45.4492 0ZM45.4492 61.6602C38.3413 61.6602 32.5586 67.4429 32.5586 74.5508C32.5586 79.1976 35.0731 83.4354 39.0039 85.7108V93.8867C39.0039 97.4407 41.8953 100.332 45.4492 100.332C49.0032 100.332 51.8945 97.4407 51.8945 93.8867V85.7108C55.8253 83.4354 58.3398 79.1979 58.3398 74.5508C58.3398 67.4429 52.5571 61.6602 45.4492 61.6602Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6758 51.9922H13.2227C11.4438 51.9922 10 53.4359 10 55.2148V74.5508C10 94.0973 25.9027 110 45.4492 110C64.9957 110 80.8984 94.0973 80.8984 74.5508V55.2148C80.8984 53.4359 79.4547 51.9922 77.6758 51.9922ZM48.6719 83.6645V93.8867C48.6719 95.6665 47.229 97.1094 45.4492 97.1094C43.6695 97.1094 42.2266 95.6665 42.2266 93.8867V83.6645C38.4756 82.3341 35.7812 78.7521 35.7812 74.5508C35.7812 69.2199 40.1183 64.8828 45.4492 64.8828C50.7801 64.8828 55.1172 69.2199 55.1172 74.5508C55.1172 78.7521 52.4228 82.3341 48.6719 83.6645Z",
    fill: "url(#paint1_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 90.8984,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 10,
    y: 51.9922,
    width: 70.8984,
    height: 60.0078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 45.4492,
    y1: 100.332,
    x2: 45.4492,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#A0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DC1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 4.66594,
    y1: -7.1757,
    x2: 96.4146,
    y2: -1.39524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordBig);
export default __webpack_public_path__ + "static/media/password_big.3ece57f4542eb0e534532ea2e7b1260d.svg";
export { ForwardRef as ReactComponent };